import React, { useState } from "react";
import { ProgressBar } from "../../../Other/ProgressBar/ProgressBar";
import "./bulkUploadOverlay.scss";

const BulkUpload = ({
  file,
  progress: { isUploading, progressCount = 50 },
  handleDeleteFile,
}) => {
  return (
    <>
      <div className="uploader-wrapper">
        <ProgressBar
          barWidth={`${Math.round(progressCount)}%`}
          barMinWidth="0%"
          progressCount={progressCount}
          variant="v2"
        />
      </div>
    </>
  );
};

export default BulkUpload;
